var _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerLinking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_1314_1",
    "data-name": "Component 1314 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_85977",
    "data-name": "Group 85977",
    transform: "translate(-41.143 -33.904)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54215",
    "data-name": "Path 54215",
    d: "M17.257,11.481l2.822-2.822a4.7,4.7,0,0,0-6.645-6.645L10.612,4.837",
    transform: "translate(45.516 40.267)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1913",
    "data-name": "Line 1913",
    y1: 9.482,
    x2: 9.482,
    transform: "translate(52.936 45.457)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54216",
    "data-name": "Path 54216",
    d: "M4.54,10.846,1.519,13.867a4.7,4.7,0,0,0,6.645,6.645l3.021-3.021",
    transform: "translate(48 37.844)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16534",
    "data-name": "Rectangle 16534",
    width: 32,
    height: 32,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerLinking);
export default __webpack_public_path__ + "static/media/CustomerLinking.aa2fa1cea72c2bbe67c3d1cae0f0a66a.svg";
export { ForwardRef as ReactComponent };